export default __webpack_public_path__ + "static/coolvetica-b9d8a93dec08b0ae6c1995107c4fe30a.otf";